import AudienceTableHeaderContainer from './AudienceTableHeader';

export default AudienceTableHeaderContainer;
